import { styled } from "@mui/material/styles";
import Button from "@mui/material/Button";
import { grey } from "@mui/material/colors";

export const WhiteButton = styled(Button)(({ theme }) => ({
  color: theme.palette.getContrastText("#FFFFFF"),
  backgroundColor: "#FFFFFF",
  "&:hover": {
    backgroundColor: grey[100],
  },
}));

export const TransparentButton = styled(Button)(({ theme }) => ({
  color: theme.palette.getContrastText(grey[700]),
  backgroundColor: "transparent",
  "&:hover": {
    backgroundColor: "rgba(255, 255, 255, 0.7)",
    color: theme.palette.getContrastText(grey[100]),
  },
  "&.button--active": {
    backgroundColor: "#FFFFFF",
    color: theme.palette.getContrastText(grey[100]),
  },
}));

export const GreyButton = styled(Button)(({ theme }) => ({
  color: theme.palette.getContrastText(grey[700]),
  backgroundColor: "rgba(255, 255, 255, 0.2)",
  "&:hover": {
    backgroundColor: "rgba(255, 255, 255, 0.5)",
  },
}));

export const GreyOutlinedButton = styled(Button)(({ theme }) => ({
  color: theme.palette.getContrastText(grey[700]),
  backgroundColor: "transparent",
  borderColor: "rgba(255, 255, 255, 0.5)",
}));
